/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dimmer.css'
import { Spring, config } from 'react-spring/renderprops.cjs'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

export class VideoPlayer extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      playing: true,
      loadedData: false,
      loadedDataPessimistic: false,
      isPessimistic: false
    }
    this.toggleVideo = this.toggleVideo.bind(this)
    this.swap = this.swap.bind(this)
    this.handleLoadedData = this.handleLoadedData.bind(this)
    this.handleLoadedDataPessimistic = this.handleLoadedDataPessimistic.bind(
      this
    )
  }

  toggleVideo() {
    // console.log(this.props.videoRef)
    if (this.state.playing) {
      this.props.videoRef.current.pause()
      this.props.videoRefPessimistic.current.pause()
      this.props.syncVideos()
    } else {
      this.props.videoRef.current.play()
      this.props.videoRefPessimistic.current.play()
    }
    this.setState({
      playing: !this.state.playing
    })
  }

  swap() {
    this.setState({
      isPessimistic: !this.state.isPessimistic
    })
  }

  handleLoadedData() {
    this.setState({ loadedData: true })
  }

  handleLoadedDataPessimistic() {
    this.setState({ loadedDataPessimistic: true })
  }

  render() {
    return (
      <div className='videoplayer' onClick={() => this.toggleVideo()}>
        <div className='wrapper'>
          <div className='spacer'>
            <img
              className='poster ui image fluid'
              src={
                this.props.isMobile
                  ? this.props.posterImage
                  : this.props.posterImageDesktop
              }
            />
          </div>
          {this.state.playing && this.state.loadedData && (
            <div className='play-status'>
              <Spring
                from={{ op: 100, size: 0 }}
                to={{
                  op: 0,
                  size: this.props.isMobile ? 1 : 2
                }}
                config={{
                  duration: 400
                }}
              >
                {props => (
                  <i
                    className='play icon massive'
                    style={{
                      opacity: props.op / 100,
                      transform: 'scale(' + props.size + ')'
                    }}
                  />
                )}
              </Spring>
            </div>
          )}
          {!this.state.playing && this.state.loadedData && (
            <div className='pause-status'>
              <Spring
                from={{ op: 100, size: 0 }}
                to={{
                  op: 0,
                  size: this.props.isMobile ? 1 : 2
                }}
                config={{
                  duration: 400
                }}
              >
                {props => (
                  <i
                    className='pause icon massive'
                    style={{
                      opacity: props.op / 100,
                      transform: 'scale(' + props.size + ')'
                    }}
                  />
                )}
              </Spring>
            </div>
          )}

          <video
            className={
              this.state.isPessimistic ? 'optimstic hidden' : 'optimstic'
            }
            ref={this.props.videoRef}
            onLoadedData={this.handleLoadedData}
            autoPlay
            muted
            playsInline
            loop
          >
            <source
              src={
                this.props.isMobile ? this.props.webm : this.props.webmDesktop
              }
              type='video/webm'
            />
            <source
              src={this.props.isMobile ? this.props.mp4 : this.props.mp4Desktop}
              type='video/mp4'
            />
          </video>

          {this.props.mp4DesktopPessimistic && (
            <video
              className={
                this.state.isPessimistic ? 'pessimistic' : 'pessimistic hidden'
              }
              ref={this.props.videoRefPessimistic}
              onLoadedData={this.handleLoadedDataPessimistic}
              autoPlay
              muted
              playsInline
              loop
            >
              <source
                src={
                  this.props.isMobile
                    ? this.props.webmPessimistic
                    : this.props.webmDesktopPessimistic
                }
                type='video/webm'
              />
              <source
                src={
                  this.props.isMobile
                    ? this.props.mp4Pessimistic
                    : this.props.mp4DesktopPessimistic
                }
                type='video/mp4'
              />
            </video>
          )}

          {this.state.loadedData && (
            <button
              onClick={() => this.toggleVideo()}
              className={
                this.props.isMobile
                  ? 'control ui icon button tiny'
                  : 'control ui icon button'
              }
            >
              <i
                className={
                  this.state.playing
                    ? this.state.isPessimistic
                      ? 'pause icon red'
                      : 'pause icon green'
                    : this.state.isPessimistic
                    ? 'play icon red'
                    : 'play icon green'
                }
              />
            </button>
          )}

          {!this.state.loadedData && (
            <div className='loading-wrapper'>
              <img
                className='poster ui image fluid'
                src={
                  this.props.isMobile
                    ? this.props.posterImage
                    : this.props.posterImageDesktop
                }
              />
              <div
                className='ui active dimmer'
                style={{ background: 'transparent' }}
              >
                <div className='ui text loader'>
                  <span>wird geladen</span>
                </div>
              </div>
            </div>
          )}
          <Waypoint
            bottomOffset='-50%'
            onEnter={event => {
              if (this.state.playing) {
                this.props.rewindVideo()
              }
            }}
          >
            <span style={{ position: 'absolute' }}>&nbsp;</span>
          </Waypoint>
        </div>
      </div>
    )
  }
}
